A candidate's response to a privacy policy consent component in the questionnaire.
